<!-- src/views/pages/superadmin/packages/packages-table.vue -->
<script>
import {
  getDiscountedPlanPrice,
} from "@/utils/planPricing";

export default {
  name: "PackagesTable",
  props: {
    plans: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["edit", "delete", "sync-annual-license"],
  data() {
    const columns = [
      {
        sorter: false,
      },
      {
        title: "Plan Name",
        dataIndex: "Plan_Name",
        key: "Plan_Name",
        sorter: {
          compare: (a, b) => {
            const x = (a.Plan_Name || "").toLowerCase();
            const y = (b.Plan_Name || "").toLowerCase();
            return x > y ? -1 : y > x ? 1 : 0;
          },
        },
      },
      {
        title: "Commercial Model",
        dataIndex: "Plan_Type",
        sorter: {
          compare: (a, b) => {
            const x = (a.Plan_Type || "").toLowerCase();
            const y = (b.Plan_Type || "").toLowerCase();
            return x > y ? -1 : y > x ? 1 : 0;
          },
        },
      },
      {
        title: "Total Subscribers",
        dataIndex: "Total_Subscribers",
        sorter: {
          compare: (a, b) => {
            const x = Number(a.Total_Subscribers || 0);
            const y = Number(b.Total_Subscribers || 0);
            return x - y;
          },
        },
      },
      {
        title: "Base Price",
        dataIndex: "Price",
        sorter: {
          compare: (a, b) => {
            const x = (a.Price || "").toLowerCase();
            const y = (b.Price || "").toLowerCase();
            return x > y ? -1 : y > x ? 1 : 0;
          },
        },
      },
      {
        title: "Annual Licence Fee",
        dataIndex: "License_Fee",
        sorter: {
          compare: (a, b) => {
            const x = (a.License_Fee || "").toLowerCase();
            const y = (b.License_Fee || "").toLowerCase();
            return x > y ? -1 : y > x ? 1 : 0;
          },
        },
      },
      {
        title: "Public Price",
        dataIndex: "Public_Price",
        sorter: {
          compare: (a, b) => {
            const x = (a.Public_Price || "").toLowerCase();
            const y = (b.Public_Price || "").toLowerCase();
            return x > y ? -1 : y > x ? 1 : 0;
          },
        },
      },
      {
        title: "Created Date",
        dataIndex: "Created_Date",
        sorter: {
          compare: (a, b) => {
            const x = (a.Created_Date || "").toLowerCase();
            const y = (b.Created_Date || "").toLowerCase();
            return x > y ? -1 : y > x ? 1 : 0;
          },
        },
      },
      {
        title: "Status",
        dataIndex: "Status",
        key: "Status",
        sorter: {
          compare: (a, b) => {
            const x = (a.Status || "").toLowerCase();
            const y = (b.Status || "").toLowerCase();
            return x > y ? -1 : y > x ? 1 : 0;
          },
        },
      },
      {
        title: "",
        key: "action",
        sorter: true,
      },
    ];

    const rowSelection = {
      onChange: () => {},
      onSelect: () => {},
      onSelectAll: () => {},
    };

    return {
      columns,
      rowSelection,
    };
  },
  computed: {
    dataSource() {
      const formatCurrency = (currency, amount) => {
        const code =
          (currency || "").toUpperCase() === "KES"
            ? "KES"
            : (currency || "").toUpperCase();

        return `${code} ${Number(amount || 0).toFixed(2)}`;
      };

      return this.plans.map((p) => {
        const createdAt = p.created_at
          ? new Date(p.created_at).toLocaleDateString()
          : "";

        const priceNum = Number(p.price || 0);
        const licenseFee = Number(p.license_fee || 0);
        const currency = (p.currency || "").toUpperCase();
        const publicPrice = getDiscountedPlanPrice(p);

        return {
          ...p,
          key: p.id,
          id: p.id,
          Plan_Name: p.name,
          Plan_Type: p.is_contact_sales ? "Contact Sales" : "Self Service",
          Total_Subscribers: p.total_subscribers ?? 0,
          Price: formatCurrency(currency, priceNum),
          License_Fee: formatCurrency(currency, licenseFee),
          Public_Price: p.is_contact_sales ? "Contact Sales" : formatCurrency(currency, publicPrice),
          Created_Date: createdAt,
          Status: p.status === "inactive" ? "Inactive" : "Active",
        };
      });
    },
  },
};
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="dataSource"
    :row-selection="rowSelection"
    :loading="loading"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Plan_Name'">
        <h6 class="fw-medium">
          <a href="javascript:void(0);">{{ record.Plan_Name }}</a>
        </h6>
      </template>

      <template v-else-if="column.key === 'Status'">
        <span
          :class="[
            'badge',
            record.Status === 'Active' ? 'badge-success' : 'badge-danger',
            'd-inline-flex',
            'align-items-center',
            'badge-sm',
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>{{ record.Status }}
        </span>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a href="javascript:void(0);" class="me-2" title="Sync plan settings" @click="$emit('sync-annual-license', record)">
            <i class="ti ti-refresh"></i>
          </a>
          <a
            href="javascript:void(0);"
            class="me-2"
            @click="$emit('edit', record)"
          >
            <i class="ti ti-edit"></i>
          </a>
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            @click="$emit('delete', record)"
          >
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>

      <template v-else>
        {{ record[column.dataIndex] }}
      </template>
    </template>
  </a-table>
</template>
